import Store from "@/services/store";
import ConfirmationModalComponent from "../../components/confirmation-modal.component";

export default {
    name: "OthersForm",
    components: {
        ConfirmationModalComponent
    },
    data() {
        return {
            data: {
                name: null,
                value: {
                    status: false
                },
                facility_id: null,
            },
            successVisible: false,
            showError: false,
            error: false
            
        };
    },
    async created() {
        await this.fetchFixedGuestCountSettings();
    },
    methods: {
        async fetchFixedGuestCountSettings() {
            try {
                const response = await this.$lionheart.get("/fixed-guest-count");
                this.data = response.data.data || this.data;

            } catch (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                this.showError = true;
            }
        },
        async savedFixGuestCount(facilityId) {

            const payload = {
                status: this.data?.value?.status
            }

            if (!facilityId) {
                Store.commit("checkin-site/loading", true);
            } else {
                Store.commit("checkin-site/loading", false);

                try {
                    await this.$lionheart.put(`/fixed-guest-count/${facilityId}`, payload);

                    this.successVisible = true;

                } catch (error) {
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }

                    this.showError = true;
                }
            }
        },
        handleConfirm() {
            this.$bvModal.show("modal-confirmation");
        }
    }
};